import React, { useEffect, useState } from 'react';
import {
  Edit,
  TabbedForm,
  FormTab,
  required,
  TextInput,
  NumberInput,
  FileInput,
  useDataProvider,
} from 'react-admin';

import { TinyMCEEditor } from 'Components/Inputs';
import { nonNegativeInt, validateFolderNumber } from '../../utils/validation';
const nonNegativeIntValidation = [required(), nonNegativeInt];
const folderNumberValidation = [required(), validateFolderNumber];
import { ActionButton } from 'Components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import SaveDeleteToolbar from 'Components/Toolbars/SaveDeleteDefault';

const EventEvidenceEdit = (props) => {
  const { resource, id } = props;
  const [templates, setTemplates] = useState([]);
  const dataProvider = useDataProvider();
  const { eventId, hasEditor, record } = props?.location?.state
  const handlePdfLiveView = () => {
    window.open(record.pdf?.url)
  }
  useEffect(() => {
    dataProvider
    .getList('template', {})
    .then(({ data }) => {
      const templateData = data.map(({ id, name, template }) => ({ id, name, template }));
      setTemplates(templateData);
    })
    .catch((error) => {
      console.log(error);
    });
      
  }, []);
  return (
    <Edit {...props} title={`resources.${resource}.titles.edit`} >
      <TabbedForm
        redirect = {`/event/${eventId}/1`}
        toolbar = {
          <SaveDeleteToolbar deleteRedirect={`/event/${eventId}`}/>
        }
        >  
        <FormTab label="Editor">
        {/* <div className={formClass.main}> */}
        <TextInput
            source="name"
            label="Name"
            validate={required()}
          />
          <NumberInput
            source="folderNumber"
            validate={folderNumberValidation}
          />
          <NumberInput
            source="orderIndex"
            validate={nonNegativeIntValidation}
          />
          <NumberInput
            source="requiredActors"
            validate={nonNegativeIntValidation}
          />
        {/* </div> */}
        <ActionButton
            label="View Live Pdf"
            onClick={handlePdfLiveView}
            style={{ width: 'auto'}}
            icon={<FontAwesomeIcon icon={faEye} />}
        />
        {
          hasEditor?<TinyMCEEditor source="content" templates={templates} editorWidth='802px'/>:null
        }
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

export default EventEvidenceEdit;
